import InlineSVG from '~/components/InlineSVG.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('InlineSvg', InlineSVG)
})
